import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash'

export interface AppStateType {
  loading: boolean
}

const initialState: AppStateType = {
  loading: false
}
export const slice = createSlice({
  name: 'appstate',
  initialState,
  reducers: {
    testAction: (state, action) => {
      state = initialState
    },
    showLoadingIndicator: (state) => {
      state.loading = true
    },
    hideLoadingIndicator: (state) => {
      state.loading = false
    },
  },
});

export const {
  testAction,
  showLoadingIndicator,
  hideLoadingIndicator
} = slice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
// export const incrementAsync = amount => dispatch => {
//   setTimeout(() => {
//     dispatch(incrementByAmount(amount));
//   }, 1000);
// };

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`

export default slice.reducer;
